import { useEffect, useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'

import * as api from '../api/client'
import { useLogin, useMe } from '../api/hooks'

export default function Login() {
  const { data: user, isLoading } = useMe()
  const login = useLogin()
  const nav = useNavigate()
  const loc = useLocation()
  const qc = useQueryClient()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  // Единый вход СиР. Обычно человек сюда даже не попадает: если общая кука cir-id годная,
  // /api/me впускает его сам и экран входа не показывается. Кнопка нужна тем, кто нажал
  // «Выйти» (BFF после этого молчит, пока его не попросят явно) и тем, у кого единый вход
  // почему-то не сработал — тогда рядом видно причину, а не просто пустой экран.
  const [sso, setSso] = useState<api.SsoInfo>({ enabled: false, cookie: false })
  const [ssoВхожу, setSsoВхожу] = useState(false)
  const [ssoОшибка, setSsoОшибка] = useState('')

  useEffect(() => {
    let живо = true
    // Перерисовываем только когда есть что показать: «единый вход выключен» — это и есть
    // начальное состояние, и лишний рендер формы входа ничего не добавляет.
    void api.fetchSso().then((s) => { if (живо && (s.enabled || s.cookie)) setSso(s) })
    return () => { живо = false }
  }, [])

  // уже вошли — не показываем форму повторно
  if (!isLoading && user) return <Navigate to="/deals" replace />

  const from = (loc.state as { from?: string } | null)?.from || '/deals'

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    login.mutate({ username, password }, { onSuccess: () => nav(from, { replace: true }) })
  }

  const войтиЧерезCirId = async () => {
    setSsoОшибка('')
    setSsoВхожу(true)
    try {
      await api.ssoCirId()
      // Перечитываем /api/me: права приходят там, и без этого первый экран нарисовался бы
      // с меню всех разделов подряд (так же поступает useLogin).
      await qc.invalidateQueries({ queryKey: ['me'] })
      nav(from, { replace: true })
    } catch (e) {
      setSsoОшибка((e as Error).message || 'единый вход не ответил')
    } finally {
      setSsoВхожу(false)
    }
  }

  return (
    <div className="login-wrap">
      <form className="card login-box" onSubmit={submit}>
        <div className="brand" style={{ marginBottom: 16 }}>
          CiR Core CRM
          <small>вход для сотрудников</small>
        </div>

        {sso.enabled && (
          <div style={{ marginBottom: 16 }}>
            <button className="primary" type="button" onClick={войтиЧерезCirId}
                    disabled={ssoВхожу} style={{ width: '100%' }}>
              {ssoВхожу ? 'Вхожу…' : 'Войти через порталы СиР'}
            </button>
            <div className="hint" style={{ marginTop: 6 }}>
              {sso.cookie
                ? 'Вы уже вошли на портал СиР — пароль вводить не нужно.'
                : 'Работает, если вы уже вошли на портал 55 или 73.'}
            </div>
            {ssoОшибка && (
              <div className="error" style={{ marginTop: 8 }}>{ssoОшибка}</div>
            )}
          </div>
        )}

        <div className="row">
          <label htmlFor="u">Логин</label>
          <input id="u" value={username} onChange={(e) => setUsername(e.target.value)} autoFocus autoComplete="username" />
        </div>

        <div className="row">
          <label htmlFor="p">Пароль</label>
          <input id="p" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        </div>

        {login.isError && (
          <div className="error" style={{ marginBottom: 12 }}>
            {(login.error as Error).message === 'unauthorized' ? 'Неверный логин или пароль' : (login.error as Error).message}
          </div>
        )}

        <button className="primary" type="submit" disabled={login.isPending || !username || !password} style={{ width: '100%' }}>
          {login.isPending ? 'Вхожу…' : 'Войти'}
        </button>
      </form>
    </div>
  )
}
